// src/features/tenants/hooks/useSuspendTenant.ts
//
// Submission seam for the "تعلیق تننت" flow.
// Owns loading/error state around suspendTenant API call.

import { useState } from 'react';

import { suspendTenant } from '../api/tenants.api';

export function useSuspendTenant() {
  const [suspending, setSuspending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(id: string) {
    setSuspending(true);
    setError(null);

    try {
      const tenant = await suspendTenant(id);
      return tenant;
    } catch (err) {
      setError('خطا در تعلیق تننت. لطفاً دوباره تلاش کنید.');
      throw err;
    } finally {
      setSuspending(false);
    }
  }

  function resetError() {
    setError(null);
  }

  return {
    submit,
    suspending,
    error,
    resetError,
  };
}
